export default __webpack_public_path__ + "static/chunks/ui-assets/pattern-mixed-black/57dcde7cbd677903841026a52df4641c.png";